const getTutorialUrlValue = (tutorialUrl) => {
  if (typeof tutorialUrl === 'string') {
    return tutorialUrl;
  }

  if (tutorialUrl && typeof tutorialUrl === 'object') {
    return String(
      tutorialUrl.url ??
      tutorialUrl.href ??
      tutorialUrl.link ??
      ''
    );
  }

  return '';
};

const parseTutorialUrls = (tutorialUrls) => {
  if (Array.isArray(tutorialUrls)) {
    return tutorialUrls;
  }

  if (typeof tutorialUrls === 'string') {
    const trimmedTutorialUrls = tutorialUrls.trim();

    if (!trimmedTutorialUrls) {
      return [];
    }

    try {
      const parsedTutorialUrls = JSON.parse(trimmedTutorialUrls);
      return Array.isArray(parsedTutorialUrls) ? parsedTutorialUrls : [trimmedTutorialUrls];
    } catch (error) {
      return [trimmedTutorialUrls];
    }
  }

  return [];
};

const sanitizeTutorialUrl = (tutorialUrl) => getTutorialUrlValue(tutorialUrl).trim();

const isValidTutorialUrl = (url) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
  } catch (error) {
    return false;
  }
};

export const createEmptyTutorialUrl = () => '';

export const normalizeTutorialUrlsForEditor = (tutorialUrls) => (
  parseTutorialUrls(tutorialUrls)
    .map((tutorialUrl) => getTutorialUrlValue(tutorialUrl))
);

export const normalizeTutorialUrls = (tutorialUrls) => (
  normalizeTutorialUrlsForEditor(tutorialUrls)
    .map((tutorialUrl) => tutorialUrl.trim())
    .filter(Boolean)
    .filter((tutorialUrl, index, urls) => urls.indexOf(tutorialUrl) === index)
);

export const validateTutorialUrls = (tutorialUrls, itemLabel = 'Tutorial URL') => {
  const urls = normalizeTutorialUrlsForEditor(tutorialUrls);

  for (let index = 0; index < urls.length; index += 1) {
    const tutorialUrl = sanitizeTutorialUrl(urls[index]);

    if (!tutorialUrl) {
      continue;
    }

    if (!isValidTutorialUrl(tutorialUrl)) {
      return `${itemLabel} ${index + 1} must use a valid http:// or https:// URL.`;
    }
  }

  return '';
};
